// https://digital.vfc.com/wiki/display/ECOM15/Loyalty+Contents
export default {

}
